import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { DropdownFrameComponent } from '../dropdown-frame/dropdown-frame.component';
import { DataService, FlagService, ValidationService } from '@core/services';
import { faIdCard, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { HIPInsuredPersonDto } from '../../../modules/_services/api/@generated/models';
import { APIClient } from '../../../modules/_services/api/@generated';

@Component({
  selector: 'app-socsecurity-juncture',
  templateUrl: './socsecurity-juncture.component.html',
  styleUrls: ['./socsecurity-juncture.component.scss'],
  standalone: false
})
export class SocsecurityJunctureComponent implements OnInit, AfterViewInit {
  faInfoCircle = faInfoCircle;
  faIdCard = faIdCard;
  validationStarted = false;

  insurantData = this.DropdownFrame.returnInsurantData();

  _socsecNumberInput = '';
  _socsecNumberInputIsValid = false;
  _missingSocSecNumber = false;

  _taxNumberInput = '';
  _taxNumberInputIsValid = false;
  _missingTaxNumber = false;

  _passportNumberInput = '';
  _passportNumberInputIsValid = false;

  public errorMessage = '';

  constructor(private DropdownFrame: DropdownFrameComponent, public FlagService: FlagService, public ValidationService: ValidationService,
              private api: APIClient,
              private dataService: DataService) { }

  @Output() newInsurantDataEvent = new EventEmitter<any>();
  @Output() newInsurantDataLocation = new EventEmitter<string>();

  ngOnInit(): void {
    this._missingTaxNumber = false;

    const person = sessionStorage.getItem('HIPInsuredPersonFromHIPDto');
    if (person) {
      const personObj = JSON.parse(person);
      if (personObj.insuredPerson) {
        this.loadDataFromSessionStorage(personObj.insuredPerson);
      }
    }
  }

  ngAfterViewInit(): void {
    window.scrollTo(0, this.dataService.fixInfoContainerHeight + 215 + (this.dataService.isPartneri() ? 65 : 0));
  }

  private loadDataFromSessionStorage(data: HIPInsuredPersonDto): void {
    if (!data.socialSecurityNumber && !data.taxNumber && !data.passport) {
      // nothing to load
      return;
    }

    if (data.socialSecurityNumber) {
      this._socsecNumberInput = data.socialSecurityNumber;
      this._socsecNumberInputIsValid = true;
    } else {
      this._missingSocSecNumber = true;
      this.missingSocSecNumber();

      if (data.taxNumber) {
        this._taxNumberInput = data.taxNumber;
        this._taxNumberInputIsValid = true;
      } else {
        this._missingTaxNumber = true;
        this.missingTaxNumber();

        this._passportNumberInput = data.passport;
        this._passportNumberInputIsValid = true;
      }
    }
  }

  missingSocSecNumber(event: any = null) {
    if (event) {
      this._missingSocSecNumber = event.target.checked;
    }
    this.validationStarted = false;

    this._socsecNumberInputIsValid = false;
    this._taxNumberInputIsValid = false;
    this._passportNumberInputIsValid = false;

    this._missingTaxNumber = false;

    if (this._missingSocSecNumber) {
      this._socsecNumberInput = '';
    } else {
      this._passportNumberInput = '';
      this._taxNumberInput = '';
    }
  }

  missingTaxNumber() {
    this.validationStarted = false;

    this._socsecNumberInputIsValid = false;
    this._taxNumberInputIsValid = false;
    this._passportNumberInputIsValid = false;

    if(this._missingTaxNumber) {
      this._taxNumberInput = '';
    } else {
      this._passportNumberInput = '';
    }
  }

  socsecNumberValidation(input: string) {
    if(this.ValidationService.socsecNumberValidator(input)) {
      this._socsecNumberInputIsValid = true;
    } else {
      this._socsecNumberInputIsValid = false;
    }
  }

  //8398282061 - 1976-01-18
  taxNumberValidation(input: string) {
    if(this.ValidationService.taxNumberValidator(input, this.insurantData.insuredPerson.birthDate)) {
      this._taxNumberInputIsValid = true;
    } else {
      this._taxNumberInputIsValid = false;
    }
  }

  passportNumberValidation(input: string) {
    if(this.ValidationService.passportNumberValidator(input)) {
      this._passportNumberInputIsValid = true;
    } else {
      this._passportNumberInputIsValid = false;
    }
  }

  public checkUserdata(): void {
    this.validationStarted = true;
    this.errorMessage = '';

    const rq = {
      koopFrameContractId: JSON.parse(sessionStorage.getItem('HIPContract')).koopFrameContractId,
      socialSecurityNumber: this._socsecNumberInput,
      taxNumber: this._taxNumberInput,
      passport: this._passportNumberInput,
    };
    this.api.checkDuplicateDocumentNumbers(rq).subscribe((rs) => {
      this.sendUserdata();
    }, (err) => {
      if (err && err.error && err.error.text === 'OK' &&
        err.status === 200 && err.statusText === 'OK') {
        this.sendUserdata();
      } else if (err && err.error &&
        err.error.validationErrors && err.error.validationErrors.length > 0 &&
        err.error.validationErrors[0].errorMessage) {
        this.errorMessage = err.error.validationErrors[0].errorMessage;
      }
    });
  }

  sendUserdata() {
    this.validationStarted = true;

    if(this._missingSocSecNumber) {
      if(!this._passportNumberInputIsValid && !this._taxNumberInputIsValid) {
        return
      }
    } else {
      if(!this._socsecNumberInputIsValid) {
        return
      }
    }


    this._socsecNumberInput === ''? this.insurantData.insuredPerson.socialSecurityNumber = null : this.insurantData.insuredPerson.socialSecurityNumber = this._socsecNumberInput;
    this._taxNumberInput === ''? this.insurantData.insuredPerson.taxNumber = null : this.insurantData.insuredPerson.taxNumber = this._taxNumberInput;
    this._passportNumberInput === ''? this.insurantData.insuredPerson.passport = null : this.insurantData.insuredPerson.passport = this._passportNumberInput;

    this.socsecurityJunctureClick();
    this.newInsurantDataLocation.emit('socsecNumber');
    this.newInsurantDataEvent.emit(this.insurantData.insuredPerson);
  }

  socsecurityJunctureClick() {
    this.DropdownFrame.junctureClick('contactinfoJunctureFlag', 5);
  }
}
